<template>
  <b-form class="py-4">
    <b-form-row>
      <b-col class="mx-2" style="text-align: center !important">
        <span class="sg-sub-heading-text">
          Become a Guider
        </span>
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="5">
        <b-form-input
          v-model="guider.first_name"
          id='input-first-name'
          placeholder="First Name"
          type="text"
        />
      </b-col>
      <b-col cols="5">
        <b-form-input
          v-model="guider.last_name"
          id='input-last-name'
          placeholder="Last Name"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="10">
        <b-form-input
          v-model="guider.email"
          id='input-email'
          placeholder="Email"
          type="text"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="5">
        <b-form-input
          v-model="guider.password"
          id='input-password'
          placeholder="Password"
          type="password"
        />
      </b-col>
      <b-col cols="5">
        <b-form-input
          v-model="guider.confirm_password"
          id='input-confirm-password'
          placeholder="Confirm Password"
          type="password"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-3">
      <b-col cols="6">
        <b-form-select
          v-model="guider.location_country"
          id="input-location-country"
          :options="location_country_options"
        />
      </b-col>
    </b-form-row>

    <b-form-row class="justify-content-center mt-4">
      <b-col cols="6">
        <b-button variant="success" block @click="createGD" :disabled="register_button_state">
          Register
        </b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component
import InputSelect from '@/templates/InputSelect'

// api call
import UserAPI from '@/api/UserAPI'
import AdminCountryAPI from '@/api/AdminCountryAPI'

export default {
  name: 'FormRegisterGuider',
  components: {
    InputSelect
  },
  mounted: function () {
    this.getLocationCountry()
  },
  data () {
    return {
      guider: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        location_country: null
      },
      location_country_options: [
        { value: null, text: 'Location', disabled: true }
      ],

      register_button_state: false,
      errors: []
    }
  },
  methods: {
    // PREREQUISITES
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    childData (id, value) {
      // catch value from custom form template
      this.guider[id] = value
    },
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null
    },
    // END PREREQUISITES

    // HTTP REQUEST
    getLocationCountry: async function () {
      let response = await AdminCountryAPI.fetchAll()

      response.data.country.forEach(location => {
        this.location_country_options.push({ value: location.country_name, text: '-- ' + location.country_name + ' --', disabled: true })

        location.city.forEach(city => {
          this.location_country_options.push({ value: city._id, text: city.city_name })
        })
      })
    },
    createGD: async function () {
      this.register_button_state = true
      this.errors = []

      if (this.isEmptyOrSpaces(this.guider.first_name)) this.errors.push('First name is Required.')
      if (this.isEmptyOrSpaces(this.guider.last_name)) this.errors.push('Last name is Required.')
      if (this.isEmptyOrSpaces(this.guider.email)) this.errors.push('Email is Required.')
      else if (!this.validEmail(this.guider.email)) this.errors.push('Email is invalid, please use another one.')
      if (this.isEmptyOrSpaces(this.guider.password)) this.errors.push('You need to fill the password field.')
      if (this.isEmptyOrSpaces(this.guider.confirm_password)) this.errors.push('You forget to fill confirmation password.')
      if (this.guider.password !== this.guider.confirm_password) this.errors.push('Password is not match.')
      if (!this.guider.location_country) this.errors.push('Your current location is required.')

      if (this.errors.length) {
        swal({
          title: 'Please check your input again.',
          text: this.errors[0],
          icon: 'error',
          button: {
            text: 'Ok'
          },

          closeOnClickOutside: false,
          closeOnEsc: false
        })

        this.register_button_state = false
      } else {
        try {
          await UserAPI.createGD(this.guider)

          this.$router.push({ name: 'Support_RegisterComplete' })
        } catch (error) {
          let msg = error.response.data

          swal({
            title: 'Failed',
            text: msg,
            icon: 'error',
            button: {
              text: 'Ok'
            },

            closeOnClickOutside: false,
            closeOnEsc: false
          })

          this.register_button_state = false
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scope>
  .sg-sub-heading-text {
    color: #233c7c;
    font-size: 32px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/templates/FormRegisterGuider/FormRegisterGuider.vue